module.exports = __webpack_public_path__ + "img/arh_15.410ab945.png";